import { api } from './client';

export const exportConfig = (): Promise<void> =>
  api.get('/config/export', { responseType: 'blob' }).then((res) => {
    const url = window.URL.createObjectURL(res.data as Blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `webadmin-config-${new Date().toISOString().slice(0, 10)}.tar.gz`;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    setTimeout(() => { URL.revokeObjectURL(url); link.remove(); }, 60_000);
  });
